import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { DashboardPage } from '@/features/projects/ui/DashboardPage';
import { monthSearchParam } from '@/features/timesheet/model/searchParams';

// Tab mặc định (gallery) vắng khỏi URL; giá trị lạ coi như không có.
const canvasParam = z.unknown().transform((v) => (v === 'kanban' || v === 'workload' ? v : undefined)).optional();
// `by=person` là mặc định nên vắng khỏi URL. month/by chỉ có nghĩa ở canvas "workload".
const byParam = z.unknown().transform((v) => (v === 'project' ? ('project' as const) : undefined)).optional();

export const Route = createFileRoute('/_authenticated/projects/dashboard')({
  validateSearch: z.object({ canvas: canvasParam, month: monthSearchParam, by: byParam }),
  component: function ProjectsDashboard() {
    const { canvas, month, by } = Route.useSearch();
    const navigate = Route.useNavigate();
    return (
      <DashboardPage
        canvas={canvas}
        load={canvas === 'workload' ? { month, by } : undefined}
        onCanvas={(c) => navigate({ search: { canvas: c === 'gallery' ? undefined : c }, replace: true })}
        onLoadChange={(next) => void navigate({
          search: (prev) => ({ canvas: prev.canvas, month: next.month ?? prev.month, by: (next.by ?? prev.by ?? 'person') === 'project' ? 'project' : undefined }),
          replace: true,
        })}
      />
    );
  },
});
